// Compute a child's age in whole years from a YYYY-MM-DD birth date string.
// Returns null when the birth date is missing, malformed, or in the future.
export function ageYears(birthDate) {
  if (!birthDate) return null;
  const d = new Date(birthDate);
  if (Number.isNaN(d.getTime())) return null;
  const now = new Date();
  let years = now.getFullYear() - d.getFullYear();
  const monthDiff = now.getMonth() - d.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < d.getDate())) {
    years -= 1;
  }
  if (years < 0 || years > 130) return null;
  return years;
}

// Short pill label — "3y", "12y", "<1y". Empty string when unknown.
export function ageLabel(birthDate) {
  const y = ageYears(birthDate);
  if (y === null) return "";
  if (y === 0) return "<1y";
  return `${y}y`;
}
